export interface ViaCepResponse {
  cep: string
  logradouro: string
  complemento: string
  bairro: string
  localidade: string
  uf: string
  ibge: string
  gia: string
  ddd: string
  siafi: string
  erro?: boolean
}

export const fetchAddressByCep = async (cep: string): Promise<ViaCepResponse> => {
  const cleanCep = cep.replace(/\D/g, '')

  if (cleanCep.length !== 8) {
    throw new Error('CEP inválido')
  }

  const response = await fetch(`https://viacep.com.br/ws/${cleanCep}/json/`)

  if (!response.ok) {
    throw new Error('Erro ao buscar o CEP')
  }

  const data: ViaCepResponse = await response.json()

  if (data.erro) {
    throw new Error('CEP não encontrado')
  }

  return data
}
